import { InstructorSearchResultInfo } from '@interfaces/Instructor'
import { ISearchInstructorFilters } from '@interfaces/ISearchInstructorFilters'

const collator = new Intl.Collator(undefined, {
  numeric: true,
  sensitivity: 'base',
})

class InstructorSearchResult {
  instructors?: InstructorSearchResultInfo[]
  sort?: string
  length?: number

  constructor(instructors?: InstructorSearchResultInfo[]) {
    this.instructors = instructors || []
  }

  getLang(value?: string) {
    return value ? value.split(';').join(', ') : ''
  }

  sortByName(a: InstructorSearchResultInfo, b: InstructorSearchResultInfo) {
    return collator.compare(a?.Name || '', b?.Name || '')
  }

  sortByScore(a: InstructorSearchResultInfo, b: InstructorSearchResultInfo) {
    return (b.SortScore || 0) - (a.SortScore || 0)
  }

  getResults(filters: ISearchInstructorFilters) {
    const results = (this.instructors || [])
      ?.filter(instructor => {
        const speaks = filters.speaks?.length
          ? filters.speaks.some(lang => instructor.SpokenLanguages?.includes(lang))
          : true

        const specialisation = filters.specialisation?.length
          ? filters.specialisation.some(specialty => instructor.Specialization?.includes(specialty))
          : true

        const name = filters.name
          ? instructor.Name?.toLocaleLowerCase().includes(filters?.name.toLocaleLowerCase())
          : true

        // to be displayed in the cards
        instructor.DisplayLang = this.getLang(instructor.SpokenLanguages)
        return speaks && specialisation && name
      })
      .sort(this[this.sort || 'sortByScore'])

    this.length = results.length
    return results
  }

  set SortValue(value: string) {
    this.sort = value
  }
}

export default InstructorSearchResult
